export default "__VITE_ASSET__2040a8f5__"